/**
 * Выбор языка тренировки в шапке.
 *
 * Рядом с темой, а не на отдельном экране настроек: язык тренировки меняют не
 * раз и навсегда — русский пользователь берётся за латиницу и возвращается
 * обратно. Прятать такой переключатель значит закрывать половину приложения
 * тому, кто выбрал язык на первом входе не задумываясь.
 *
 * Подпись видна, а не только объявлена: «Русский | Английский» без неё
 * читается как язык интерфейса, а это другая настройка.
 */

import type { LanguageCode } from '@type2x/shared-contracts';
import { LANGUAGES } from '@type2x/shared-contracts';
import type { Translate } from '@type2x/i18n';
import { Button } from '@type2x/ui';

export interface LanguageBarProps {
  readonly t: Translate;
  /** Текущий язык тренировки. */
  readonly language: LanguageCode;
  readonly onLanguageChange: (language: LanguageCode) => void;
}

export function LanguageBar({
  t,
  language,
  onLanguageChange,
}: LanguageBarProps): React.JSX.Element {
  return (
    <div className="t2x-language" role="group" aria-label={t('language.training')}>
      <span className="t2x-language__label t2x-muted">{t('language.training')}</span>
      {LANGUAGES.map((option) => (
        <Button
          key={option}
          variant={option === language ? 'primary' : 'ghost'}
          onClick={() => onLanguageChange(option)}
          // Выбранный язык отмечен не только цветом кнопки: цвет здесь
          // единственным носителем смысла быть не может (UX-12).
          aria-pressed={option === language}
        >
          {t(`onboarding.language.${option}`)}
        </Button>
      ))}
    </div>
  );
}
